import React from 'react';
import styled, { css } from 'styled-components';
import { blueColor, lightGrey2Color, busyBackground } from 'js/config/style';
import chroma from 'chroma-js';

const buttonColor = chroma('#d9d9d9');

const primaryButton = css`
  border-radius: 0 0 0.5rem 0;
  border-left: 1px solid ${lightGrey2Color};
  grid-column: 2;

  &:active {
    box-shadow: 1px 1px 11px -5px black inset;
  }
`;

const secondaryButton = css`
  border-radius: 0 0 0 0.5rem;
  grid-column: 1;

  &:active {
    box-shadow: -1px 1px 11px -5px black inset;
  }
`;

const transparentBackground = css`
  background: transparent;
`;

const hoverBackground = css`
  background: rgba(0, 0, 0, 0.05);
`;

export default styled(({ isBusy, defaultButton, ...rest }) => <button {...rest} />)`
  padding: 0.5rem;
  color: ${({ color }) => color || blueColor};
  border-radius: 0 0 0.5rem 0.5rem;
  border: none;
  font-weight: ${({ defaultButton }) => (defaultButton ? '700' : '500')};
  line-height: 2rem;
  cursor: pointer;
  grid-row: 1;

  ${({ isBusy }) => (isBusy ? busyBackground(buttonColor) : transparentBackground)}
  ${({ defaultButton }) => (defaultButton ? primaryButton : secondaryButton)};

  &:hover {
    ${({ isBusy }) => (isBusy ? busyBackground(buttonColor) : hoverBackground)}
    cursor: ${({ isBusy }) => (isBusy ? 'default' : 'pointer')};
  }
`;
